module.exports = __webpack_public_path__ + "static/media/M1-7-Zurkana-cod106.b7308203.png";